<template>
  <el-row class="seller-header">
    <!-- 网站logo start -->
    <el-col :span="12" class="seller-header-logo">
      <span>仓壹佰 · 跨境电商代发平台</span>
    </el-col>
    <!-- 网站logo end -->
    <el-col :span="12" class="seller-header-right">
      <!-- 操作指南 start -->
      <div class="seller-header-rightItem seller-header-linkBtn seller-header-help">
        <a href="https://www.cang100.com/operate.html" target="_blank"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.1442 24.9985C9.61622 25.0944 5.04961 20.6346 5.00154 15.1199C4.90543 9.60513 9.32779 5.09743 14.8558 5.00152C20.3838 4.90561 24.9504 9.36537 24.9985 14.8801C25.0946 20.3949 20.6722 24.9505 15.1442 24.9985V24.9985ZM15 20.8744C15.673 20.8744 16.2017 20.3469 16.2017 19.6755C16.2017 19.0042 15.673 18.4767 15 18.4767C14.327 18.4767 13.7983 19.0042 13.7983 19.6755C13.7983 20.3469 14.327 20.8744 15 20.8744ZM15 8.55014C12.7888 8.55014 11.0102 9.70104 10.9141 11.859C10.9141 11.9549 10.866 12.0028 10.866 12.0988C10.866 12.7701 11.3948 13.2976 12.0678 13.2976C12.7407 13.2976 13.2695 12.7701 13.2695 12.0988C13.2695 11.1397 14.0386 10.3244 15.0481 10.3244C16.0095 10.3244 16.8266 11.0917 16.8266 12.0988C16.8747 13.3456 15.673 13.8731 15.0481 14.4485C13.654 15.5994 13.8463 16.2228 13.8463 16.2228C13.8463 16.8942 14.3751 17.4217 15.0481 17.4217C15.673 17.4217 16.2017 16.8942 16.2498 16.2708C16.9228 15.3597 18.0284 14.5444 18.0284 14.4965C19.134 13.5374 19.2301 12.1467 19.2301 12.1467C19.134 9.79694 17.2593 8.55014 15 8.55014V8.55014Z" fill="#ECF4F3"/>
        </svg></a>
      </div>
      <!-- 操作指南 end -->

      <!-- 客服 start -->
      <div class="seller-header-rightItem seller-header-linkBtn seller-header-service">
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.1036 21.3564C15.2146 21.3564 15.3276 21.3498 15.4413 21.3367C16.5318 21.21 17.4579 20.4718 17.7997 19.4545C17.8255 19.3784 17.7883 19.2969 17.713 19.2635C17.6387 19.2299 17.5486 19.2589 17.5066 19.3272C17.5026 19.3337 17.0693 20.0114 15.3825 20.232C15.1299 20.2649 14.8842 20.2821 14.6513 20.2821C13.4695 20.2813 12.9429 19.85 12.938 19.846C12.8786 19.7948 12.7878 19.7934 12.7268 19.8433C12.6653 19.8932 12.6511 19.9799 12.6931 20.0463C13.2076 20.854 14.1308 21.3564 15.1036 21.3564ZM24.1736 11.2324C24.1587 11.2324 24.1452 11.235 24.131 11.235C23.1427 7.09115 19.3661 4 14.8382 4C10.1857 4 6.32249 7.26185 5.46623 11.5772C4.63368 11.7223 4 12.431 4 13.288V16.718C4 17.6794 4.79606 18.459 5.77898 18.459C6.33343 18.459 6.82282 18.2054 7.14837 17.816C7.93499 19.8308 9.5364 21.4554 11.5631 22.3125C11.5679 22.3023 11.6063 22.23 11.6524 22.1725C11.6843 22.1325 11.7201 22.0998 11.7508 22.0998C11.7826 22.0998 11.8117 22.111 11.8367 22.1281C11.3676 21.7899 9.67335 20.0515 9.30636 17.6255C9.14534 16.5578 9.97119 15.5096 10.933 15.3362C12.4771 15.0578 14.0131 14.7406 15.5571 14.4674C16.5387 14.2941 17.2095 13.7726 17.6196 12.9044C17.7158 12.7015 17.8546 12.2911 17.9182 11.6993C17.9351 11.6114 18.0096 11.5438 18.1051 11.5438C18.1688 11.5438 18.2229 11.5753 18.2588 11.6206L18.3014 11.595C18.91 12.4507 20.1168 14.3453 20.2902 16.343C20.4892 18.6271 20.3782 20.1914 18.5729 21.7918C18.5708 21.7938 18.568 21.7964 18.5654 21.7984C18.5404 21.8246 18.5255 21.8588 18.5255 21.8963C18.5255 21.9455 18.5525 21.9875 18.5918 22.0131C18.6067 22.0191 18.6216 22.027 18.6365 22.0329C18.6486 22.0355 18.6602 22.0394 18.6724 22.0394C18.6846 22.0394 18.6954 22.0355 18.7062 22.0329C18.7319 22.0198 18.7563 22.0046 18.7813 21.9915C20.607 21.0175 22.0075 19.3909 22.6547 17.4345C22.9167 17.8114 23.3269 18.0827 23.8034 18.1773C23.0391 21.5435 19.9389 23.6503 16.098 23.9701C15.8679 23.4172 15.3013 23.0245 14.6358 23.0245C13.7667 23.0245 13.0621 23.6911 13.0621 24.5126C13.0621 25.3342 13.7666 26 14.6358 26C15.3365 26 15.9234 25.564 16.1271 24.9651C20.5731 24.6151 24.1371 22.0558 24.8812 18.0794C25.5384 17.8134 26 17.1889 26 16.4599V12.9892C26 12.0192 25.1822 11.2324 24.1736 11.2324ZM22.5335 12.2293C21.3739 9.18737 18.3691 7.0143 14.8342 7.0143C11.3141 7.0143 8.3201 9.16896 7.14974 12.1912C7.09151 12.1222 7.02321 12.0632 6.95618 12.0034C7.61875 8.3205 10.8918 5.52031 14.8382 5.52031C18.7657 5.52031 22.0285 8.29296 22.7128 11.9503C22.6452 12.0383 22.5829 12.1301 22.5335 12.2293ZM11.5633 22.3125C11.5632 22.3125 11.5632 22.3125 11.5631 22.3125C11.5623 22.3141 11.5623 22.3143 11.5633 22.3125Z" fill="#ECF4F3"/>
        </svg>
        <div class="seller-header-linkBtn-content">
          <img src="../../assets/img/serviceQRCode.jpg">
        </div>
      </div>
      <!-- 客服 end -->

      <!-- 账号余额 start -->
      <el-dropdown>
        <div class="seller-header-rightItem seller-header-balance">
          <span>账号余额</span>
          <div class="seller-header-balance-container">
            <span class="seller-header-balance-currency">{{ accountBalance?accountBalance.CurrencyCode:'' }}</span>
            <span class="seller-header-balance-content">{{ accountBalance?accountBalance.Balance:'--' }}</span>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item
            v-for="currencyItem in currencyType"
            :key="currencyItem.value"
            @click.native="setCurrencyType(currencyItem.value)">{{ currencyItem.label }}</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 账号余额 end -->

      <!-- 语言切换 start TODO: 待实现 -->
      <!-- <el-dropdown>
        <div class="seller-header-rightItem seller-header-language">
          <i class="iconfont iconheader-language" />
        </div>
        <el-dropdown-menu slot="dropdown"> -->
          <!-- TODO: 在下面的dropdown-item重设置click事件处理语言切换功能 -->
          <!-- <el-dropdown-item
            v-for="languageItem in languageType"
            :key="languageItem.value">{{ languageItem.label }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <!-- 语言切换 end -->

      <!-- 用户下拉 start -->
      <el-dropdown @command="handleCommand">
        <div class="seller-header-rightItem seller-header-user">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15H0Z" fill="#68B0AB"/>
            <path d="M14.865 15.3438C16.8496 15.3438 18.465 13.8254 18.465 11.9573C18.465 10.0904 16.8496 8.5719 14.865 8.5719C12.8804 8.5719 11.265 10.0904 11.265 11.9573C11.265 13.8254 12.8804 15.3438 14.865 15.3438ZM13.485 15.9646C10.9788 15.9646 9.1073 17.5869 9.1073 19.9431V20.1969C9.1073 21.4281 11.1127 21.4281 13.6511 21.4281H16.3477C18.7869 21.4281 20.8938 21.4281 20.8938 20.1969V19.9431C20.8938 17.5869 19.0211 15.9646 16.515 15.9646H13.485Z" fill="#ECF4F3"/>
          </svg>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="/recharge">账号充值</el-dropdown-item>
          <el-dropdown-item command="/dealRecords">交易记录</el-dropdown-item>
          <!-- <el-dropdown-item command="/userManage">账号管理</el-dropdown-item> -->
          <el-dropdown-item command="/setting">设置</el-dropdown-item>
          <el-dropdown-item><div @click="logoutFN">登出</div></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 用户下拉 end -->
    </el-col>
  </el-row>
</template>

<script>
import { Notification } from 'element-ui'
// api
import { logout } from '../../api/user'
import { getAccountRequest } from '../../api/common'

export default {
  name: 'seller-header',
  data () {
    return {
      accountBalance: { // 账户余额信息
        Balance: '', // 账户余额
        CurrencyCode: '' // 余额币种
      },
      currencyType: [{ // 货币种类数据
        value: 0, // 货币类型编号
        label: '人民币 CNY' // 货币名称
      }, {
        value: 1,
        label: '美元 USD'
      }, {
        value: 2,
        label: '港元 HDK'
      }, {
        value: 3,
        label: '日元 JPY'
      }],
      languageType: [{ // 语言数据
        value: 0, // 语言编号
        label: '简体中文' // 语言名称
      }, {
        value: 1,
        label: '繁体中文'
      }, {
        value: 2,
        label: 'English'
      }, {
        value: 3,
        label: '日本语'
      }]
    }
  },
  mounted () {
    // 监听余额
    this.bus.$on('accountBalance', (data) => {
      this.accountBalance = data
    })
    // 请求账户余额
    getAccountRequest().then((data) => {
      if (data.Code === 1) {
        // 处理Balance字段
        if (data.Records.length) {
          this.accountBalance = { // 设置余额信息
            Balance: data.Records[0].Balance,
            CurrencyCode: data.Records[0].CurrencyCode
          }
        } else {
          this.accountBalance = {
            Balance: '0',
            CurrencyCode: ''
          }
        }
      }
    })
  },
  methods: {
    /**
     * 余额货币类型切换
     * @param {Number} type 货币类型编号
     */
    setCurrencyType (type) {
      switch (type) {
        case 0: // 人民币
          this.balance.label = `￥${this.balance.count}`
          break
        case 1: // 美元
          this.balance.label = `$${this.balance.count}`
          break
        case 2: // 港元
          this.balance.label = `HK$${this.balance.count}`
          break
        case 3: // 日元
          this.balance.label = `J￥${this.balance.count}`
          break
      }
    },

    /**
     * 页面跳转
     */
    handleCommand (command) {
      if (command) {
        this.$router.push(command)
      }
    },

    /**
     * 登出功能
     */
    logoutFN () {
      logout().then(data => {
        if (data.Code === 1) {
          Notification({
            title: '登出成功',
            type: 'success'
          })
          window.localStorage.setItem('autoLogin', false)
          this.$router.push('/login?1')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.seller-header {
  height: 60px;
  display: flex;
  align-items: center;
  color: #ECF4F3;
  background: #006A71;
  .el-col {
    height: 100%;
    font-size: 0;
  }
  .el-dropdown {
    color: #ECF4F3;
  }
  // 网站logo start
  .seller-header-logo {
    display: flex;
    align-items: center;
    padding-left: 30px;
    box-sizing: border-box;
    span {
      font-size: 18px;
      letter-spacing: 2px;
    }
  }
  // 网站logo end

  // 右侧内容 start
  .seller-header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 40px;
    text-align: right;
  }
  .seller-header-rightItem {
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
  }
  // 右侧按钮通用样式
  .seller-header-linkBtn {
    display: flex;
    align-items: center;
    height: 60px;
    &:hover {
      background: #ECF4F3;
      path {
        fill: #006A71;
      }
    }
  }
  // 右侧内容 end

  // 客服 start
  .seller-header-service {
    position: relative;
    .seller-header-linkBtn-content {
      display: flex;
      align-items: center;
      height: 0;
      padding: 0 10px;
      position: absolute;
      top: 70px;
      right: 0;
      border-radius: 5px;
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
      transition: height .3s;
      overflow: hidden;
      background: #FFF;
      img {
        width: 150px;
        opacity: 0;
        transition: opacity .3s;
      }
    }
    &:hover {
      .seller-header-linkBtn-content {
        height: 170px;
        img {
          opacity: 1;
        }
      }
    }
  }
  // 客服 end

  // 账号余额 start
  .seller-header-balance {
    span {
      letter-spacing: 1px;
      font-size: 14px;
      line-height: 60px;
      text-align: center;
      vertical-align: middle;
    }
    .seller-header-balance-container {
      display: inline-block;
      padding-left: 10px;
      font-size: 0;
      vertical-align: middle;
      span {
        font-size: 18px;
        font-weight: 600;
      }
      .seller-header-balance-currency {
        padding-right: 5px;
        font-size: 12px;
      }
    }
    &:hover {
      color: #006A71;
      background: #ECF4F3;
    }
  }
  // 账号余额 end

  // 语言选择 start
  .seller-header-language {
    vertical-align: middle;
    font-size: 0;
    i {
      font-size: 28px;
      line-height: 60px;
    }
    &:hover {
      color: #006A71;
      background: #ECF4F3;
    }
  }
  // 语言选择 end

  // 用户下拉 start
  .seller-header-user {
    vertical-align: middle;
    font-size: 0;
    svg {
      width: 28px;
      height: 60px;
      padding-bottom: 3px;
      box-sizing: border-box;
    }
    &:hover {
      background: #ECF4F3;
      path:first-child {
        fill: #006A71;
      }
    }
  }
  // 用户下拉 end
}

// 下拉窗样式 start
.el-dropdown-menu {
  min-width: 150px;
  padding: 0;
  border-radius: 5px;
  .el-dropdown-menu__item {
    padding: 10px 20px 9px;
    border-bottom: solid 1px #DDD;
    color: #4a4a4a;
    line-height: 20px;
    letter-spacing: 1px;
    &:nth-last-child(2) {
      border: none;
      padding: 0;
      div {
        padding: 10px 20px 9px;
      }
    }
    &:hover {
      color: #4a4a4a;
      background: #ECF4F3;
    }
  }
  .popper__arrow {
    display: none;
  }
}
// 下拉窗样式 end
</style>



// WEBPACK FOOTER //
// src/layout/component/header.vue